import React from "react";
import { Table } from "antd";
import { Button, Switch, Tag, Input } from "../../../../../../BP2Components";
import IntlMessages from "../../../../../../../util/IntlMessages";
import { Icon_Edit } from "../../../../../../BP2Components/Icons/icons";

const SharingDetails = ({ dataSource, setShareOption, detailsLoading }) => {
   const columns = [
      {
         title: <IntlMessages id="boardsManager.name" />,
         dataIndex: "name",
         key: "name"
      },
      {
         title: <IntlMessages id="boardsManager.permission" />,
         dataIndex: "permission",
         key: "permission",
         render: (_, record) => <Input value={record.permission} style={{ width: 150 }} disabled />
      },
      {
         title: <IntlMessages id="boardsManager.showInMainNav" />,
         dataIndex: "showInMainNav",
         key: "showInMainNav",
         className: "minor",
         render: (_, record) => <Switch checked={record.showInMainNav} disabled />
      },
      {
         title: <IntlMessages id="boardsManager.type" />,
         dataIndex: "type",
         key: "type",
         className: "minor",
         render: (_, record) => (
            <span>
               {
                  <Tag>
                     {record?.type == "users" ? (
                        <IntlMessages id="boardsManager.users" />
                     ) : (
                        <IntlMessages id="boardsManager.groups" />
                     )}
                  </Tag>
               }
            </span>
         )
      },
      {
         title: <IntlMessages id="global.actions" />,
         dataIndex: "actions",
         key: "actinos",
         render: (_, record) => (
            <div>
               <Button
                  buttonType="primary"
                  className="button-edit"
                  onClick={() => setShareOption(record?.type)}
               >
                  <Icon_Edit />
               </Button>
            </div>
         )
      }
   ];

   return (
      <Table
         size="small"
         dataSource={dataSource}
         loading={detailsLoading}
         columns={columns}
         pagination={false}
      />
   );
};

export default SharingDetails;
